import axios from '../wmsAxios'

/*
 * 处理流程资源模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/rfProcessResource/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/rfProcessResource/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/rfProcessResource/findPage',
        method: 'post',
        data
    })
}

// 获取资源
export const getProcessResources = (params) => {
    return axios({
        url: '/rfProcessResource/getProcessResources',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/rfProcessResource.js